import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function activityReducer(state = initialState.activityState, action) {
    switch(action.type) {
        case types.GET_ACTIVITY_FEED:   
        {        
            const activityFeed = action.activityFeed;
            return {
                ...state,
                activityFeed,
                lastLoaded: new Date()
            };
        }
        case types.GET_ACTIVITY_FEED_STATUS:
        {
            return {
                ...state,
                loadingStatus: action.loadingStatus
            };
        }
        case types.CLEAR_ACTIVITY_FEED:   
        {        
            return {
                ...state,
                activityFeed: [],
                lastLoaded: null
            };
        }
        default:
            return state;
    }
}